module.exports = __webpack_public_path__ + "img/seal0.59975cc8.png";